export const MAIN_SITE_URL = "https://kaspreadsheet.com";
export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string) || "https://basetaosheet.cam";
export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/0dc5bc4081b05862da3d01553c9c9d93.png";